var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { AbstractRequestManager } from './IRequest';
var DefaultRequestManager = /** @class */ (function (_super) {
    __extends(DefaultRequestManager, _super);
    function DefaultRequestManager() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.reqName = (_this.expr || 'r = obj').replace(/^r ?= ?/, '').split(',').map(function (r) { return r.trim(); });
        return _this;
    }
    DefaultRequestManager.prototype.getRequestObj = function () {
        var req = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            req[_i] = arguments[_i];
        }
        return this.reqName.reduce(function (pre, cur, index) {
            var _a;
            return (__assign({}, pre, (_a = {}, _a[cur] = req[index], _a)));
        }, {});
    };
    return DefaultRequestManager;
}(AbstractRequestManager));
export { DefaultRequestManager };
